(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carosello-loghi-Qshops"] && !window.DesignMode) return;
  try {
    
// Assicurati di includere la libreria Slick o un'altra libreria di carosello JavaScript nel tuo tema per utilizzare questo script
$(document).ready(function(){
  $('.brand-logos-container').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  });
});

  } catch(e) { console.error(e); }
})();
})();
